import Consumer from './consumer';

const extend = function (object: any, properties: any)
{
    if (properties != null)
    {
        for (const key in properties)
        {
            const value = properties[key];
            object[key] = value;
        }
    }
    return object;
};

export default class Subscription
{
    consumer: Consumer;
    readonly identifier: string;

    /**
     * Constructor
     */
    constructor(consumer: Consumer, params: object = {}, mixin: object)
    {
        this.consumer   = consumer;
        this.identifier = JSON.stringify(params);
        extend(this, mixin);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Perform a channel action with the optional data passed as an attribute
     */
    perform(action: string, data: any = {}): boolean
    {
        data.action = action;
        return this.send(data);
    }

    send(data: any): boolean
    {
        return this.consumer.send({ command: 'message', identifier: this.identifier, data: JSON.stringify(data) });
    }

    unsubscribe(): Subscription
    {
        return this.consumer.subscriptions.remove(this);
    }
}
